import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HeaderService } from './header.service';
import { Observable } from 'rxjs/Observable';
import { IDBResponse, EDBResponseType } from '../../common/responses';
import { Network } from '../../common/network';

@Injectable()
export class NetworkService {
    
    constructor(private $http: Http, private $header: HeaderService){}
    
    
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_services/network.service.ts